/*
 * Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, OnDestroy, OnInit, Input } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { MerchantService } from "../../../../services/merchant.service";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { MerchantMigrationDetails } from "../../../../models/merchant";

@Component({
  selector: "app-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html"
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  onClose!: Subject<boolean>;
  @Input()
  merchantMigrationInfo!: MerchantMigrationDetails;
  faCheck = faCheck;

  constructor(private bsModalRef: BsModalRef, private merchantService: MerchantService) {}

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  handleConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }

  getConfirmationMessage(): string {
    return this.merchantMigrationInfo.toBeMigrated
      ? this.merchantService.generateMigrationInfoVerbiage(this.merchantMigrationInfo)
      : `Do you want to proceed with migrating ${this.merchantMigrationInfo.previousMerchantName} to an InstaMed merchant?`;
  }

  ngOnDestroy(): void {
    this.onClose.unsubscribe();
  }
}
